//Defining endpoint

module.exports = {
    url: {
        general: "https://api.cursocloudaws.net/tracker/",
        oteador: "https://api.cursocloudaws.net/oteador/",      
    } 
}









// WEBPACK FOOTER //
// ./src/api.js